// extracted by mini-css-extract-plugin
export default {"departmentLabel":"Department-module__departmentLabel___znmrU"};